import { InjectionToken } from '@angular/core';
import { IAppConfiguration, IAppSession } from '@smarsh-cyber/core';

export const SMARSH_CYBER_APP_CONFIG = new InjectionToken<IAppConfiguration>(
  'SMARSH.CYBER.APP.CONFIG'
);

export const SMARSH_CYBER_APP_SESSION = new InjectionToken<IAppSession>(
  'SMARSH.CYBER.APP.SESSION'
);
